import { useState } from 'react';
import { Box, InlineButton, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/NotificationsListFilter';
import {
  NOTIFICATIONS_LIST_FILTERS,
  type NotificationsListFilters,
} from './types';

TEXT.DEFINE({
  /** Filter label for all notifications */
  all: 'All',
  /** Filter label for unread notifications only */
  unread: 'Unread',
});

type NotificationsListFilter = {
  onPress: any;
  filter: NotificationsListFilters;
};

function getTextColorForFilter(
  filter: NOTIFICATIONS_LIST_FILTERS,
  filterSelected: NOTIFICATIONS_LIST_FILTERS,
  filterHovered: NOTIFICATIONS_LIST_FILTERS | null
) {
  if (filter === filterSelected) {
    return 'primary';
  }
  if (filter === filterHovered) {
    return 'secondary';
  }
  return 'tertiary';
}

export const NotificationsListFilter = ({
  onPress,
  filter: filterSelected,
}: NotificationsListFilter) => {
  const [filterHovered, setFilterHovered] =
    useState<null | NotificationsListFilters>(null);

  return (
    <Box display="flex" gap={16} paddingLeft={8}>
      <InlineButton
        aria-checked={filterSelected === NOTIFICATIONS_LIST_FILTERS.ALL}
        data-testid="all-notifications"
        onHoverEnd={() => setFilterHovered(null)}
        onHoverStart={() => setFilterHovered(NOTIFICATIONS_LIST_FILTERS.ALL)}
        onPress={() => onPress(NOTIFICATIONS_LIST_FILTERS.ALL)}
        size="small"
      >
        <Text
          color={getTextColorForFilter(
            NOTIFICATIONS_LIST_FILTERS.ALL,
            filterSelected,
            filterHovered
          )}
          variant="body"
        >
          {TEXT.all}
        </Text>
      </InlineButton>
      <InlineButton
        aria-checked={filterSelected === NOTIFICATIONS_LIST_FILTERS.UNREAD}
        onHoverEnd={() => setFilterHovered(null)}
        onHoverStart={() => setFilterHovered(NOTIFICATIONS_LIST_FILTERS.UNREAD)}
        onPress={() => onPress(NOTIFICATIONS_LIST_FILTERS.UNREAD)}
        size="small"
      >
        <Text
          color={getTextColorForFilter(
            NOTIFICATIONS_LIST_FILTERS.UNREAD,
            filterSelected,
            filterHovered
          )}
          variant="body"
        >
          {TEXT.unread}
        </Text>
      </InlineButton>
    </Box>
  );
};
